import { c } from 'react-compiler-runtime';
import { FilteredActionList as FilteredActionList$2 } from './FilteredActionListWithDeprecatedActionList.js';
import { FilteredActionList as FilteredActionList$1 } from './FilteredActionListWithModernActionList.js';
import { jsx } from 'react/jsx-runtime';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';

function FilteredActionList(props) {
  const $ = c(4);
  const enabled = useFeatureFlag("primer_react_select_panel_with_modern_action_list");
  if (enabled) {
    let t0;
    if ($[0] !== props) {
      t0 = /*#__PURE__*/jsx(FilteredActionList$1, {
        ...props
      });
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  } else {
    let t0;
    if ($[2] !== props) {
      t0 = /*#__PURE__*/jsx(FilteredActionList$2, {
        ...props
      });
      $[2] = props;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
}
FilteredActionList.displayName = 'FilteredActionList';

export { FilteredActionList };
